import PageInFlowWithSidebarLayout, {
  PageInFlowWithSidebarLayoutProps,
} from 'components/common/general/layouts/PageInFlowWithSidebarLayout';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import QuoteFlowDelegate from 'store/flows/quote/quoteFlowDelegate';
import QuoteSidebar from './QuoteSidebar';

interface QuoteFlowLayoutProps
  extends Omit<PageInFlowWithSidebarLayoutProps, 'sidebar' | 'moreInfoBlob' | 'domainParams'> {
  flowDelegate: QuoteFlowDelegate;
  isPageLoading?: boolean;
}

const QuoteFlowLayout: React.FC<QuoteFlowLayoutProps> = observer(({ flowDelegate, pageId, isPageLoading, ...rest }) => {
  const blobInput = flowDelegate.groupInfoDelegate.moreInfoBlobInput;

  return (
    <PageInFlowWithSidebarLayout
      {...rest}
      domainParams={flowDelegate.domainData}
      moreInfoBlob={blobInput ? buildGroupContextMoreInfoBlobProps(blobInput) : undefined}
      pageId={pageId}
      sidebar={<QuoteSidebar sidebarDelegate={flowDelegate.sidebarDelegate} pageId={pageId} />}
      isInitialLoading={isPageLoading}
      isInfoSectionLoading={flowDelegate.isFlowDataLoading}
    />
  );
});

export default QuoteFlowLayout;
